import { getAnalyticsPlugin } from '@/app/(main)/_components/logger/analytics/get-analytics-plugin';
import { getLogger } from '@/logger/logger';

const logger = getLogger('analytics.identity');

export function identifyAnalyticsUser(userId: string | undefined): void {
  if (!userId) {
    return;
  }

  try {
    getAnalyticsPlugin().identify(userId);
  } catch (error) {
    logger.error('Analytics identity not delivered', { analytics: { event: 'identify' }, error });
  }
}

export function linkOrderToAnalyticsIdentity(orderId: string): void {
  try {
    getAnalyticsPlugin().alias(orderId);
  } catch (error) {
    logger.error('Analytics order link not delivered', { analytics: { event: 'alias' }, error });
  }
}

export function resetAnalyticsIdentity(): void {
  try {
    getAnalyticsPlugin().reset();
  } catch (error) {
    logger.error('Analytics identity not cleared', { analytics: { event: 'reset' }, error });
  }
}
